/**
 * @generated SignedSource<<1ae8fae86919083e459a17a303342928>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableHeaderYMALItem_item$data = {
  readonly creators: ReadonlyArray<{
    readonly creator: {
      readonly name: string | null;
    } | null;
  } | null> | null;
  readonly isArt: boolean | null;
  readonly pdpURL: string | null;
  readonly photos: ReadonlyArray<{
    readonly masterOrZoomPath: string | null;
  } | null> | null;
  readonly serviceId: string | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"AuctionPricePaddle_item">;
  readonly " $fragmentType": "PdpRespUnavailableHeaderYMALItem_item";
};
export type PdpRespUnavailableHeaderYMALItem_item$key = {
  readonly " $data"?: PdpRespUnavailableHeaderYMALItem_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableHeaderYMALItem_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableHeaderYMALItem_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pdpURL",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemCreator",
      "kind": "LinkedField",
      "name": "creators",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Creator",
          "kind": "LinkedField",
          "name": "creator",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1
        }
      ],
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "masterOrZoomPath",
          "storageKey": null
        }
      ],
      "storageKey": "photos(limit:1)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AuctionPricePaddle_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "c55c1864afaa385148fcc30c2375e51c";

export default node;
